import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { defineMessages, useIntl } from 'react-intl';
import BreezeAddressSearch from '../../../components/BreezeAddressSearch/BreezeAddressSearch';
import BreezeHead from '../../../components/BreezeHead';
import {
  getStaticPathsForPartnersAndCentralUnits as getStaticPaths,
  getStaticProps,
} from '../../../config/getProps';

const I18N_NAMESPACE = 'SearchPage';

export const messages = defineMessages({
  pageTitle: {
    id: `${I18N_NAMESPACE}.pageTitle`,
    defaultMessage: 'Search your address | {companyName}',
  },
});

const Search = () => {
  const intl = useIntl();
  const { BU_CONFIG } = useGlobalConfig();
  return (
    <>
      <BreezeHead
        title={intl.formatMessage(messages.pageTitle, {
          companyName: BU_CONFIG.company_name,
        })}
      />

      <BreezeAddressSearch />
    </>
  );
};

export { getStaticProps, getStaticPaths };

export default Search;
